import { reduce, sumBy, size } from 'lodash/fp';

export default reduce(
  (packages, each) => [
    ...packages,
    {
      ...each,
      quantity: size(each.availability)
        ? sumBy('quantity', each.availability)
        : 0
    }
  ],
  []
);
